module.exports = function (name, value) {
  var result = getAnswer(name + '-' + String(value));
  return result || getAnswer(name);
};
